import { Navigate, Route, Routes } from 'react-router-dom';
import { differenceInCalendarDays } from 'date-fns';

import { useAppDispatch, useAppSelector } from '@/core/redux/hooks';
import { appSettingsActions } from '@/core/redux/slices/app/slice';
import { systemModalsActions } from '@/core/redux/slices/modals/smokeExtraction/system/slice';
import { usersSelectors } from '@/core/redux/slices/users/selectors';

import AirExchangeRoute from './AirExchangeRoute';

const AirExchangeRootRoute: React.FC = () => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(usersSelectors.user);

  const { payment_status, ends_at } = user?.subscription || {
    ends_at: '',
    plan_type: 'trial',
  };
  const count_days = differenceInCalendarDays(new Date(ends_at), new Date());

  const check_permission = count_days >= 0 && payment_status === 'succeeded';

  if (user?.is_legacy || check_permission) {
    return (
      <Routes>
        <Route path='/' element={<AirExchangeRoute />} />
        <Route path={'*'} element={<Navigate to={'/'} />} />
      </Routes>
    );
  } else {
    dispatch(
      appSettingsActions.setAppNotification({
        type: 'warning',
        message: 'Уведомление',
        description: 'Действие недоступно с текущим планом подписки',
      })
    );
    dispatch(systemModalsActions.openSubscriptionRequestModal());
    return (
      <Routes>
        <Route path={'*'} element={<Navigate to={'/'} />} />
      </Routes>
    );
  }
};

export default AirExchangeRootRoute;
